import React, { useState } from 'react';
import { 
  Table, Card, Button, Space, Typography, Modal, Form, 
  Input, Select, Tag, Badge, Alert, Cascader, Descriptions,
  Upload, Radio, Drawer, message
} from 'antd';
import { SearchOutlined, ReloadOutlined, PlusOutlined, SwapOutlined, CloudUploadOutlined, EyeOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const cloudOptions = [
  { value: 'V2', label: 'V2', children: [
    { value: 'cn-v2-01', label: 'China-V2-Main (cn-v2-01)', region: '国内' },
    { value: 'ap-v2-01', label: 'AsiaPacific-V2 (ap-v2-01)', region: '亚太' },
    { value: 'na-v2-01', label: 'NorthAmerica-V2 (na-v2-01)', region: '北美' },
  ]},
  { value: 'V3', label: 'V3', children: [
    { value: 'cn-v3-01', label: 'China-V3-Main (cn-v3-01)', region: '国内' },
    { value: 'cn-v3-02', label: 'China-V3-Backup (cn-v3-02)', region: '国内' },
    { value: 'ap-v3-01', label: 'AsiaPacific-V3 (ap-v3-01)', region: '亚太' },
    { value: 'na-v3-01', label: 'NorthAmerica-V3 (na-v3-01)', region: '北美' },
  ]},
];

const getCloudInfo = (val) => {
  if (!val || val.length < 2) return null;
  const ver = cloudOptions.find(v => v.value === val[0]);
  const cloud = ver?.children?.find(c => c.value === val[1]);
  return cloud ? { version: val[0], cloudName: cloud.label.split(' (')[0], cloudId: val[1], region: cloud.region } : null;
};

const mockEnterprises = { 'JGSf0Nd7': '东莞康林物联网有限公司', 'A619355x': '捷顺科技股份有限公司', 'HM-8827-X': '深圳汇云科技', 'test': '测试企业' };
const regionColor = { '国内': 'blue', '亚太': 'green', '北美': 'orange' };

const DeviceDispatch = () => {
  const [form] = Form.useForm();
  const [addForm] = Form.useForm();
  const [addVisible, setAddVisible] = useState(false);
  const [detailVisible, setDetailVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [selectedEnt, setSelectedEnt] = useState(null);
  const [inputMethod, setInputMethod] = useState('input');
  const [targetInfo, setTargetInfo] = useState(null);

  const dataSource = [
    { key: '1', entName: '东莞康林物联网有限公司', entId: 'JGSf0Nd7', beforeRegion: '国内', targetVersion: 'V3', targetCloudName: 'China-V3-Main', targetCloudId: 'cn-v3-01', afterRegion: '国内', status: 'success', operator: 'admin', time: '2026-04-01 10:00:00',
      devices: [
        { key: 'd1', license: 'LIC_001', prodName: '智能摄像机Q1', prodId: 'PROD_Q1', deviceStatus: '已激活', dispatchStatus: '成功' },
        { key: 'd2', license: 'LIC_002', prodName: '智能摄像机Q1', prodId: 'PROD_Q1', deviceStatus: '已激活', dispatchStatus: '成功' },
        { key: 'd3', license: 'LIC_003', prodName: '智能摄像机Q1', prodId: 'PROD_Q1', deviceStatus: '未激活', dispatchStatus: '成功' },
      ]
    },
    { key: '2', entName: '深圳汇云科技', entId: 'HM-8827-X', beforeRegion: '国内', targetVersion: 'V3', targetCloudName: 'AsiaPacific-V3', targetCloudId: 'ap-v3-01', afterRegion: '亚太', status: 'partial', operator: 'admin', time: '2026-04-02 09:30:00',
      devices: [
        { key: 'd4', license: 'LIC_201', prodName: '云台机P1', prodId: 'PROD_P1', deviceStatus: '已激活', dispatchStatus: '成功' },
        { key: 'd5', license: 'LIC_202', prodName: '云台机P1', prodId: 'PROD_P1', deviceStatus: '已激活', dispatchStatus: '失败' },
        { key: 'd6', license: 'LIC_203', prodName: '云台机P1', prodId: 'PROD_P1', deviceStatus: '未激活', dispatchStatus: '成功' },
      ]
    },
    { key: '3', entName: '捷顺科技股份有限公司', entId: 'A619355x', beforeRegion: '亚太', targetVersion: 'V2', targetCloudName: 'NorthAmerica-V2', targetCloudId: 'na-v2-01', afterRegion: '北美', status: 'failed', operator: 'HM_finance', time: '2026-03-28 14:30:00',
      devices: [
        { key: 'd7', license: 'LIC_301', prodName: 'ParkingCloud传感器', prodId: 'PROD_PC1', deviceStatus: '已激活', dispatchStatus: '失败' },
        { key: 'd8', license: 'LIC_302', prodName: 'ParkingCloud传感器', prodId: 'PROD_PC1', deviceStatus: '已激活', dispatchStatus: '失败' },
      ]
    },
    { key: '4', entName: '广州云联物联网有限公司', entId: 'GZ-YL-002', beforeRegion: '国内', targetVersion: 'V3', targetCloudName: 'Europe-V3', targetCloudId: 'eu-v3-01', afterRegion: '欧洲', status: 'running', operator: 'admin', time: '2026-04-08 15:00:00',
      devices: [
        { key: 'd9', license: 'LIC_401', prodName: '智能门锁S1', prodId: 'PROD_S1', deviceStatus: '已激活', dispatchStatus: '成功' },
        { key: 'd10', license: 'LIC_402', prodName: '智能门锁S1', prodId: 'PROD_S1', deviceStatus: '已激活', dispatchStatus: '待执行' },
        { key: 'd11', license: 'LIC_403', prodName: '智能门锁S1', prodId: 'PROD_S1', deviceStatus: '未激活', dispatchStatus: '待执行' },
      ]
    },
  ];

  const statusConfig = {
    running: { badge: 'processing', text: '执行中' },
    success: { badge: 'success', text: '已完成' },
    partial: { badge: 'warning', text: '部分完成' },
    failed: { badge: 'error', text: '失败' },
  };

  const columns = [
    { title: '企业信息', key: 'ent', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.entName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.entId}</Text></div>) },
    { title: '调度目标', key: 'target', width: 180, render: (_, r) => (<div><Tag>{r.targetVersion}</Tag><div style={{ fontSize: 13 }}>{r.targetCloudName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.targetCloudId}</Text></div>) },
    { title: '调度后区域', dataIndex: 'afterRegion', width: 100, render: (v) => <Tag color={regionColor[v]}>{v}</Tag> },
    { title: '任务状态', dataIndex: 'status', width: 90, render: (s) => { const c = statusConfig[s]; return <Badge status={c.badge} text={c.text} />; } },
    { title: '操作人', dataIndex: 'operator', width: 80 },
    { title: '操作时间', dataIndex: 'time', width: 170, render: (t) => <Text type="secondary">{t}</Text> },
    { title: '操作', key: 'action', width: 100, align: 'center', render: (_, r) => <Button type="link" size="small" icon={<EyeOutlined />} onClick={() => { setCurrentRecord(r); setDetailVisible(true); }}>设备明细</Button> },
  ];

  const deviceColumns = [
    { title: 'License', dataIndex: 'license', width: 160, render: (t) => <Text copyable style={{ fontFamily: 'monospace' }}>{t}</Text> },
    { title: '产品信息', key: 'prod', width: 200, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.prodName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.prodId}</Text></div>) },
    { title: '设备状态', dataIndex: 'deviceStatus', width: 100, render: (v) => <Tag color={v === '已激活' ? 'green' : 'default'}>{v}</Tag> },
    { title: '调度状态', dataIndex: 'dispatchStatus', width: 100, render: (v) => {
      const map = { '成功': 'success', '失败': 'error', '待执行': 'warning' };
      return <Badge status={map[v] || 'default'} text={v} />;
    }},
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}><Title level={4}>设备调度</Title></div>

      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Form form={form} layout="inline" style={{ flex: 1 }}>
            <Form.Item>
              <Space.Compact>
                <Form.Item name="entType" initialValue="name" noStyle><Select style={{ width: 100 }}><Option value="name">企业名称</Option><Option value="id">企业ID</Option></Select></Form.Item>
                <Form.Item shouldUpdate={(p, c) => p.entType !== c.entType} noStyle>
                  {({ getFieldValue }) => (<Form.Item name="ent" noStyle><Input placeholder={getFieldValue('entType') === 'id' ? "请输入企业ID" : "请输入企业名称"} allowClear style={{ width: 180 }} /></Form.Item>)}
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item name="status"><Select placeholder="任务状态" style={{ width: 120 }} allowClear><Option value="running">执行中</Option><Option value="success">已完成</Option><Option value="partial">部分完成</Option><Option value="failed">失败</Option></Select></Form.Item>
            <Form.Item name="license"><Input placeholder="精确查询License" allowClear style={{ width: 180 }} /></Form.Item>
            <Form.Item><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button></Space></Form.Item>
          </Form>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => { addForm.resetFields(); setSelectedEnt(null); setTargetInfo(null); setInputMethod('input'); setAddVisible(true); }}>发起设备调度</Button>
        </div>
      </Card>

      <Card bordered={false}>
        <Table columns={columns} dataSource={dataSource} rowKey="key" scroll={{ x: 1100 }}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
      </Card>

      {/* 发起设备调度 */}
      <Modal title={<Space><SwapOutlined style={{ color: '#1890ff' }} /><span>发起设备调度</span></Space>}
        open={addVisible} onOk={async () => { try { await addForm.validateFields(); Modal.confirm({ title: '确认执行设备调度？', content: '调度操作不可撤销，请确认信息无误。', onOk() { setAddVisible(false); } }); } catch(e){} }}
        onCancel={() => setAddVisible(false)} okText="立即执行" cancelText="取消" destroyOnClose width={640}
      >
        <div style={{ marginBottom: 16 }}>
          <Alert type="error" showIcon style={{ marginBottom: 8, borderRadius: 6 }}
            message={<Text strong>设备从V2调度到V3，若V3没有创建调度设备的「产品配置」，则调度到V3后设备将会变砖！反之，V3调度到V2同理。</Text>}
          />
          <Alert type="info" showIcon style={{ marginBottom: 8, borderRadius: 6 }}
            message="执行调度规则：若设备未激活，则一次调度成功。否则，将对设备逐台下发执行调度。"
          />
          <Alert type="warning" showIcon style={{ borderRadius: 6 }}
            message="切换调度目标可能会导致短暂的服务中断，请在业务低峰期操作调度。"
          />
        </div>
        <Form form={addForm} layout="vertical">
          <Form.Item name="enterpriseId" label="选择企业" rules={[{ required: true, message: '请选择企业' }]}>
            <Select placeholder="请输入企业名称搜索" showSearch optionFilterProp="children" onChange={(val) => { setSelectedEnt(mockEnterprises[val] ? { id: val, name: mockEnterprises[val] } : null); }}>
              {Object.entries(mockEnterprises).map(([id, name]) => <Option key={id} value={id}>{name}</Option>)}
            </Select>
          </Form.Item>
          {selectedEnt && (
            <div style={{ background: '#fafafa', padding: '8px 12px', borderRadius: 6, marginBottom: 16 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>企业ID：</Text><Text copyable>{selectedEnt.id}</Text>
            </div>
          )}
          <Form.Item label="输入方式">
            <Radio.Group value={inputMethod} onChange={(e) => setInputMethod(e.target.value)}>
              <Radio.Button value="input">输入License</Radio.Button>
              <Radio.Button value="import">导入License</Radio.Button>
            </Radio.Group>
          </Form.Item>
          {inputMethod === 'input' ? (
            <Form.Item name="licenses" label="输入License（每行一个）" rules={[{ required: true, message: '请输入License' }]}>
              <TextArea rows={6} placeholder="每行输入一个License，例如：&#10;LIC_001&#10;LIC_002&#10;LIC_003" />
            </Form.Item>
          ) : (
            <Form.Item name="licenseFile" label="导入License" rules={[{ required: true, message: '请上传文件' }]}>
              <Upload.Dragger maxCount={1} beforeUpload={() => false} style={{ background: '#fff' }}>
                <p className="ant-upload-drag-icon"><CloudUploadOutlined /></p>
                <p className="ant-upload-text">点击或拖拽License文件至此处上传</p>
                <p className="ant-upload-hint">支持 xlsx/xls/csv 格式，最大支持5000台设备(License)</p>
              </Upload.Dragger>
              <Button type="link" size="small" style={{ padding: 0, marginTop: 4 }} onClick={() => message.success('模板下载中...')}>下载导入模板</Button>
            </Form.Item>
          )}
          <Form.Item name="target" label="调度目标" rules={[{ required: true, message: '请选择调度目标' }]}>
            <Cascader options={cloudOptions} placeholder="请选择 V2/V3 → Cloud" onChange={(val) => setTargetInfo(getCloudInfo(val))} />
          </Form.Item>
          {targetInfo && (
            <div style={{ marginBottom: 16 }}>
              <div style={{ background: '#f6ffed', padding: '8px 12px', borderRadius: 6, border: '1px solid #b7eb8f' }}>
                <Text type="secondary" style={{ fontSize: 12 }}>所属区域：</Text><Tag color={regionColor[targetInfo.region]}>{targetInfo.region}</Tag>
              </div>
            </div>
          )}
        </Form>
      </Modal>

      {/* 设备调度明细 */}
      <Drawer
        title="设备调度明细"
        width={900}
        onClose={() => setDetailVisible(false)}
        open={detailVisible}
        destroyOnClose
      >
        {currentRecord && (
          <>
            <Descriptions bordered column={2} size="small" style={{ marginBottom: 24 }}>
              <Descriptions.Item label="企业信息"><div><div style={{ fontWeight: 500 }}>{currentRecord.entName}</div><Text type="secondary" style={{ fontSize: 12 }}>{currentRecord.entId}</Text></div></Descriptions.Item>
              <Descriptions.Item label="调度目标"><div><Tag>{currentRecord.targetVersion}</Tag><div>{currentRecord.targetCloudName}</div><Text type="secondary" style={{ fontSize: 12 }}>{currentRecord.targetCloudId}</Text></div></Descriptions.Item>
              <Descriptions.Item label="调度后区域"><Tag color={regionColor[currentRecord.afterRegion]}>{currentRecord.afterRegion}</Tag></Descriptions.Item>
              <Descriptions.Item label="任务状态"><Badge status={statusConfig[currentRecord.status].badge} text={statusConfig[currentRecord.status].text} /></Descriptions.Item>
              <Descriptions.Item label="操作人">{currentRecord.operator}</Descriptions.Item>
              <Descriptions.Item label="操作时间" span={2}>{currentRecord.time}</Descriptions.Item>
            </Descriptions>

            <Title level={5} style={{ marginBottom: 12 }}>设备明细</Title>
            <Table columns={deviceColumns} dataSource={currentRecord.devices} rowKey="key" size="small"
              pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 台设备` }} />
          </>
        )}
      </Drawer>
    </div>
  );
};

export default DeviceDispatch;
